export default function generateSwanSnippet(): string {
  return `
    (function () {
      var w = window;
      var swan = (w.swan = w.swan || []);
      if (swan.isLoaded) return;
      swan.isLoaded = true;
      swan.pk = 'cmd3kdr2c0005jr055iukzez2';
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://script.getswan.com?pk=cmd3kdr2c0005jr055iukzez2';
      var head = document.getElementsByTagName('head')[0];
      head.appendChild(script);
    })();
  `.trim()
}
